import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  root: {
    minWidth: 410,
    minHeight: 240,
    '& div.loading': {
      marginTop: 90
    },
    maxWidth: 800
  },
  table: {
  },
  tableHead: {
    width: 'calc( 100% - 1em )'
  },
  tableBody: {
    display: 'block',
    maxHeight: 340,
    overflowY: 'auto'
  },
  tableRow: {
    display: 'table',
    width: '100%',
    tableLayout: 'fixed' /* even columns width , fix width of table too*/
  }
}))

export {
  useStyles
}
